export default function JoinCTA() {
  return (
    <section id="join" className="w-full bg-background-50">
      <div className="w-full px-4 py-16 md:px-10 md:py-24">
        <div className="relative overflow-hidden rounded-lg bg-primary-500 px-6 py-14 md:px-16 md:py-20">
          <span className="absolute -right-16 -top-16 h-56 w-56 rounded-full bg-background-50/10"></span>
          <span className="absolute -bottom-24 -left-10 h-64 w-64 rounded-full bg-foreground-950/10"></span>

          <div className="relative flex flex-col items-start gap-8 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-2xl">
              <p className="text-xs tracking-[0.32em] text-accent-200">JOIN THE CIRCLE</p>
              <h2 className="mt-5 font-heading text-3xl font-bold leading-snug tracking-tight text-background-50 md:text-4xl">
                有值得分享的网址，或者想找人互换资源？
              </h2>
              <p className="mt-5 text-sm leading-loose text-background-100/90 md:text-base">
                把你的线索、站点或经验投过来，我们会先核对来源，再决定它出现在今日索引还是独家线索专区。分享从来不是单向的。
              </p>
            </div>

            <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row lg:flex-col">
              <a
                href="#groups"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-7 py-3.5 text-sm text-primary-700 transition-colors hover:bg-background-100"
              >
                <i className="ri-send-plane-line"></i>
                投稿与分享
              </a>
              <a
                href="#index"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/60 px-7 py-3.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-bookmark-line"></i>
                收藏今日索引
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}